/**
 * Telas que só existem no computador (P-C7): no celular mostram "disponível no computador" (ConfiguracaoSomenteDesktop em App.js)
 * e NÃO aparecem no menu. Fonte única da lista: toda rota de App.js envolvida em ConfiguracaoSomenteDesktop entra aqui
 * (rotasDesktop.test.js confere as duas listas).
 */
export const PREFIXOS_SOMENTE_DESKTOP = [
  '/estados',
  '/cidades',
  '/profissionais',
  '/profissionaisEspecIndex',
  '/profissionaisEspecForm',
  '/especializacoes',
  '/tiposConsultas',
  '/tiposPagtosProf',
  '/planosSaude',
  '/formasRecebimento',
  '/condicoesRecebimento',
  '/disponibilidadeSemanal',
  '/profTiposPagtos',
  '/profEspecValores',
  '/relatorios/financeiro',
  '/relatorios/renovacao-pacotes',
  '/relatorios/saldo-sem-agenda',
  '/titulosPlano',
  '/importacoes',
  '/parametros',
  '/faturasPlano',
  '/notasPlano',
  '/motivosGlosa',
  '/contasReceber',
]

export const ehSomenteDesktop = (caminho) =>
  PREFIXOS_SOMENTE_DESKTOP.some((p) => caminho === p || String(caminho).startsWith(`${p}/`))

/** No celular, tira do menu as telas só de desktop e os grupos que ficaram sem nenhum item. No desktop devolve o menu como está. */
export function filtrarMenuPorTela(itens, telaPequena) {
  if (!telaPequena) return itens
  return (itens || [])
    .map((item) => {
      if (item.submenu) {
        const submenu = filtrarMenuPorTela(item.submenu, true)
        return submenu.length ? { ...item, submenu } : null
      }
      return item.to && ehSomenteDesktop(item.to) ? null : item
    })
    .filter(Boolean)
}
